import { Component, ElementRef, Input, Optional } from '@angular/core';
import { FormValidationDirective } from '@Shared/Directives/proprietary/form-validation.directive';

@Component({
    standalone: false,
    selector: 'ep-field-block',
    template: `
    <div class="fieldBlockName">{{ displayName }}</div>
    <div class="fieldBlockContent">
      <ng-content *ngIf="!hidden"></ng-content>
    </div>
  `
})
export class FieldBlockComponent {
    @Input()
    name: string = null;

    get displayName(): string {
        if (this.name) {
            return 'Block ' + this.name.slice(5).toUpperCase(); //strip epfb_ prefix
        }
        return 'Block ?';
    }

    constructor(@Optional() private formValidationDirective: FormValidationDirective, public element: ElementRef) { }

    get hidden() {
        if (this.formValidationDirective) {
            return this.formValidationDirective.hidden(this.name);
        }
        return false;
    }
}
